import React, { useEffect, useState } from "react";
import "./GuestVisitActivities.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";

/* IMPORT IMAGES */
import img1 from "../../Asset/Images/guestvisit1.jpeg";
import img2 from "../../Asset/Images/guestvisit2.jpeg";
import img3 from "../../Asset/Images/guestvisit3.jpeg";
import img4 from "../../Asset/Images/f5.jpeg";
import img5 from "../../Asset/Images/guestvisit4.jpeg";
import img6 from "../../Asset/Images/guestvisit5.jpeg";
import img7 from "../../Asset/Images/guestvisit8.jpeg";
import img8 from "../../Asset/Images/guestvisit6.jpeg";
import img9 from "../../Asset/Images/guestvisit7.jpeg";

const images = [img1, img2, img3, img4, img5, img6, img7, img8, img9];

const GuestVisitActivities = () => {
  const { t } = useTranslation();
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  // Lock scroll when lightbox is open
  useEffect(() => {
    if (selectedImage) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => { document.body.style.overflow = "auto"; };
  }, [selectedImage]);

  return (
    <div className="photos_page">
      {/* HEADER SECTION */}
      <div className="photos_header">
        <h1>
          {t('activities.title_part1')} 
        </h1>
        <p>
          {t('activities.subtitle')}
        </p>
      </div>

      <div className="gallery_grid">
        {images.map((img, index) => (
          <div
            className="gallery_card"
            key={index}
            data-aos="zoom-in"
            data-aos-delay={index * 60}
            onClick={() => setSelectedImage(img)}
          >
            <img src={img} alt={`${t('activities.alt_text')} ${index + 1}`} loading="lazy" />
            <div className="gallery_overlay">
              <button className="open_btn">{t('activities.view_btn')}</button>
            </div>
          </div>
        ))}
      </div>

      {/* LIGHTBOX MODAL */}
      {selectedImage && (
        <div className="lightbox_overlay" onClick={() => setSelectedImage(null)}>
          <button className="lightbox_close" onClick={() => setSelectedImage(null)}>
            ×
          </button>
          <div className="lightbox_container" onClick={(e) => e.stopPropagation()}>
            <img src={selectedImage} alt={t('activities.enlarged_alt')} className="lightbox_img" />
          </div>
        </div>
      )}
    </div>
  );
};

export default GuestVisitActivities;